import * as types from './mutation_types'
import * as helpers from './helper'
import { defaultFields } from '../../data'
import store from '@/store/index'
import axios from 'axios'
import { api } from '../../../services/config'
import {
  sortPoType,
  sortCsiAdj,
  sortCsiScore,
  sortEventAwarded,
  sortEventParticipated,
  sortK3lRemaining,
  sortPoValue,
  sortRiskCategory,
  sortSpmScoring,
  sortVendorCategory,
} from '../../../services/helper'

export default {
  [types.ADD_FILTER](state, filter) {
    state.selectedFilters = filter
  },
  [types.PUSH_FILTER](state, filter) {
    let data = state.selectedFilters
    data.push(filter)
    state.selectedFilters = data
  },
  [types.ADD_ALL_FILTER](state, filter) {
    state.selectedFilters = filter
  },
  [types.RESET_ALL_FILTER](state, filter) {
    state.selectedFilters = []
  },
  [types.SET_QUERY](state, query) {
    state.query = query
  },
  [types.TOGGLE_MODAL_FETCH](state) {
    state.modalFetch = !state.modalFetch
  },
  [types.TOGGLE_SHOW_DETAIL](state) {
    state.showDetail = !state.showDetail
  },
  [types.SET_DETAIL](state, info) {
    state.detail = info
  },
  [types.RESET_STATE](state) {
    ;(state.showDetail = false),
      (state.detail = null),
      (state.totalEvent = null),
      (state.poDetail = null),
      (state.spmScoring = null),
      (state.picDetail = null),
      (state.fieldsToFilter = null),
      (state.tableFields = defaultFields),
      (state.keyword = ''),
      (state.vendorName = ''),
      (state.commodity = ''),
      (state.organization = []),
      (state.city = ''),
      (state.province = ''),
      (state.error = null),
      (state.loading = false)
    store.state.itemTable = []
    store.state.csv_data = null
    state.selectedFilters = []
  },
  [types.SET_MANUAL_FILTER](state, filter) {
    state.manualFilter = filter
  },
  async [types.SET_FILTER](state, nextPage) {
    store.state.search = null
    try {
      const filterBox = () => {
        const { fieldsToFilter } = state
        let newFilterField = []
        if (fieldsToFilter) {
          if (fieldsToFilter.length > 0) {
            fieldsToFilter.forEach(list => {
              let newField = {
                key: list.field_name,
                label: list.label,
                sortable: true,
                thClass: 'bg-subhead',
                thStyle: { borderTop: 0, verticalAlign: 'middle' },
              }
              if (list.field_name == 'PO_TYPE') newField = sortPoType(newField)
              if (list.field_name == 'CSI_FINAL_ADJ')
                newField = sortCsiAdj(newField)
              if (list.field_name == 'CSI_SCORING')
                newField = sortCsiScore(newField)
              if (list.field_name == 'EVENT_AWARDED')
                newField = sortEventAwarded(newField)
              if (list.field_name == 'EVENT_PARTICIPATED')
                newField = sortEventParticipated(newField)
              if (list.field_name == 'K3L_REMAINING_DAYS')
                newField = sortK3lRemaining(newField)
              if (list.field_name == 'PO_VALUE')
                newField = sortPoValue(newField)
              if (list.field_name == 'RISK_CATEGORY')
                newField = sortRiskCategory(newField)
              if (list.field_name == 'SPM_SCORING')
                newField = sortSpmScoring(newField)
              if (list.field_name == 'VENDOR_CATEGORY')
                newField = sortVendorCategory(newField)
              newFilterField.push(newField)
            })
            if (newFilterField.length > 0) {
              let mergeFilter = [...defaultFields, ...newFilterField]
              const unique = mergeFilter
                .map(e => e['key'])
                .map((e, i, final) => final.indexOf(e) === i && i)
                .filter(obj => mergeFilter[obj])
                .map(e => mergeFilter[e])

              state.tableFields = unique
            } else {
              state.tableFields = defaultFields
            }
          } else {
            state.tableFields = defaultFields
          }
        }
      }

      state.loading = true
      let urlCadangan = `${api}/api/v1/supplier?sort_by=vendor_name&order_by=asc&offset=0&limit=5&PERIOD_FROM=2019-01-01&PERIOD_TO=2020-01-01&CSI_SCORING_MIN=0&CSI_SCORING_MAX=100&EVENT_AWARDED_MIN=0&EVENT_AWARDED_MAX=100&EVENT_PARTICIPATED_MIN=0&EVENT_PARTICIPATED_MAX=100&SPM_SCORING_MIN=0&SPM_SCORING_MAX=100&TOTAL_VALUE_IDR_MIN=0&TOTAL_VALUE_IDR_MAX=100&VENDOR_NAME=rimba indonesia`
      let urlQuery = `${api}/api/v1/supplier?sort_by=vendor_name&order_by=asc${state.query}`

      const { data } = await axios({
        method: 'GET',
        url: `${urlQuery}`,
        timeout: 0,
        maxContentLength: 8000000000,
        maxBodyLength: 8000000000,
      })

      if (data.data) {
        let supplier = data.data
        // let poData = supplier.po
        // let picData = supplier.pic
        // let eventData  = supplier.event
        // let spmData = supplier.spm
        // let temp = {}
        const temp = supplier
        await filterBox()

        // const getPO = (info) => {
        // 	if(poData){
        // 		return poData.filter(list =>
        // 			{
        // 				if(list['SERVER'] === 'BC') return list['VENDOR_ID_SAP'] === info['VENDOR_ID_SAPBC']
        // 				if(list['SERVER'] === 'GEMS') return list['VENDOR_ID_SAP'] === info['VENDOR_ID_SAPGEMS']
        // 				if(list['SERVER'] === 'BKES') return list['VENDOR_ID_SAP'] === info['VENDOR_ID_SAPBKES']
        // 			}
        // 		)
        // 	}
        // }

        // const getPIC = (aribaId) => {
        // 	if(aribaId){
        // 		return picData.filter(list => list['VENDOR_ID_ARIBA'] === aribaId)
        // 	}
        // }

        // const getEvent = (aribaId) => {
        // 	if(aribaId){
        // 		return eventData.filter(list => list['VENDOR_ID_ARIBA'] === aribaId)
        // 	}
        // 	return []
        // }

        // const getSPM = (aribaId) => {
        // 	if(aribaId){
        // 		return spmData.filter(list => list['VENDOR_ID_ARIBA'] === aribaId)
        // 	}
        // }

        // await supplier.info.map((item, index) => {
        // 	if(temp[index] === undefined){
        // 		temp[index] = {
        // 			...item,

        // 			'po' : getPO(item),
        // 			'PIC' : item['VENDOR_ID_ARIBA'] && getPIC(item['VENDOR_ID_ARIBA']),
        // 			'EVENT' : item['VENDOR_ID_ARIBA'] && getEvent(item['VENDOR_ID_ARIBA']),
        // 			'SPM' : item['VENDOR_ID_ARIBA'] && getSPM(item['VENDOR_ID_ARIBA'])
        // 		}
        // 	}
        // })

        const alldata = Object.values(temp)
        const convertTime = 1000 * 60 * 60 * 24
        const manual = state.manualFilter
        const filterk3ldays = () => {
          if (manual) {
            if (
              manual.indexOf('K3L_REMAINING_DAYS_MIN') > -1 &&
              manual.indexOf('K3L_REMAINING_DAYS_MAX') > 1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('K3L_REMAINING_DAYS_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('K3L_REMAINING_DAYS_MAX')) + 1]
              )
              const getDays = alldata.filter(
                days =>
                  min <=
                    parseInt(
                      (new Date(days['K3L_PREQ_END_DATE']).getTime() -
                        new Date().getTime()) /
                        convertTime
                    ) &&
                  max >=
                    parseInt(
                      (new Date(days['K3L_PREQ_END_DATE']).getTime() -
                        new Date().getTime()) /
                        convertTime
                    )
              )
              if (getDays && getDays.length > 0) {
                return getDays
              }
              return []
            }
          }
          return alldata
        }
        const calculateCsiScore = value => {
          if (value && value.length > 0) {
            let count = 0
            let item = 0
            value.map(list => {
              if (list.CSI_SCORE_AVG && typeof Number) {
                count += Number(list.CSI_SCORE_AVG)
                item++
              }
            })
            if (item > 0) return Math.round(count / item)
          }
          return 0
        }

        const csiScoringFilter = () => {
          if (manual) {
            if (
              manual.indexOf('CSI_SCORING_MIN') > -1 &&
              manual.indexOf('CSI_SCORING_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('CSI_SCORING_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('CSI_SCORING_MAX')) + 1]
              )
              const getScore = filterk3ldays().filter(
                score =>
                  min <= calculateCsiScore(score.csi) &&
                  max >= calculateCsiScore(score.csi) &&
                  score.csi.length > 0
              )
              if (getScore && getScore.length > 0) {
                return getScore
              }
              return []
            }
          }
          return filterk3ldays()
        }

        const calAward = value => {
          if (value && value.length > 0) {
            let count = 0
            value.map(list => {
              if (list.EVENT_AWARDED && typeof Number) {
                count += list.EVENT_AWARDED
              }
            })
            return count
          }
        }

        const filterAwarded = () => {
          if (manual) {
            if (
              manual.indexOf('EVENT_AWARDED_MIN') > -1 &&
              manual.indexOf('EVENT_AWARDED_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('EVENT_AWARDED_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('EVENT_AWARDED_MAX')) + 1]
              )
              const award = csiScoringFilter().filter(
                score =>
                  min <= calAward(score.EVENT) &&
                  max >= calAward(score.EVENT) &&
                  score.EVENT
              )
              if (award && award.length > 0) {
                return award
              }
              return []
            }
          }
          return csiScoringFilter()
        }

        const calParticipate = value => {
          if (value && value.length > 0) {
            let count = 0
            value.map(list => {
              if (
                typeof list.EVENT_PARTICIPATED == 'number' &&
                list.EVENT_PARTICIPATED
              ) {
                count += list.EVENT_PARTICIPATED
              }
            })
            return count
          }
        }

        const filterParticipated = () => {
          if (manual) {
            if (
              manual.indexOf('EVENT_PARTICIPATED_MIN') > -1 &&
              manual.indexOf('EVENT_PARTICIPATED_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('EVENT_PARTICIPATED_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('EVENT_PARTICIPATED_MAX')) + 1]
              )
              const participate = filterAwarded().filter(
                score =>
                  min <= calParticipate(score.EVENT) &&
                  max >= calParticipate(score.EVENT)
              )
              if (participate && participate.length > 0) {
                return participate
              }
              return []
            }
          }
          return filterAwarded()
        }

        const calSpm = value => {
          if (value && value.length > 0) {
            let count = 0
            let item = 0
            value.map(list => {
              if (
                list.AVG_GRADE &&
                typeof Number &&
                Number(list.AVG_GRADE) > 0
              ) {
                count += Number(list.AVG_GRADE)
                item++
              }
            })
            if (item > 0) return Math.round(count / item)
          }
          return 0
        }

        const spmScore = () => {
          if (manual) {
            if (
              manual.indexOf('SPM_SCORING_MIN') > -1 &&
              manual.indexOf('SPM_SCORING_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('SPM_SCORING_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('SPM_SCORING_MAX')) + 1]
              )
              const getSpm = filterParticipated().filter(
                score =>
                  min <= calSpm(score.SPM) &&
                  max >= calSpm(score.SPM) &&
                  score.SPM
              )
              if (getSpm && getSpm.length > 0) {
                return getSpm
              }
              return []
            }
          }
          return filterParticipated()
        }

        const totalPo = () => {
          if (manual) {
            if (
              manual.indexOf('TOTAL_PO_RELEASED_MIN') > -1 &&
              manual.indexOf('TOTAL_PO_RELEASED_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('TOTAL_PO_RELEASED_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('TOTAL_PO_RELEASED_MAX')) + 1]
              )
              const getPo = spmScore().filter(
                score => min <= score.po.length && max >= score.po.length
              )
              if (getPo && getPo.length > 0) {
                return getPo
              }
              return []
            }
          }
          return spmScore()
        }

        const calPoValue = value => {
          if (value && value.length > 0) {
            let count = 0
            value.map(list => {
              if (list.TOTAL_VALUE_IDR && typeof Number) {
                count += Number(list.TOTAL_VALUE_IDR)
              }
            })
            return count
          }
          return 0
        }

        const poValue = () => {
          if (manual) {
            if (
              manual.indexOf('PO_VALUE_MIN') > -1 &&
              manual.indexOf('PO_VALUE_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('PO_VALUE_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('PO_VALUE_MAX')) + 1]
              )
              const getPoValue = totalPo().filter(
                score =>
                  min <= calPoValue(score.po) &&
                  max >= calPoValue(score.po) &&
                  score.po.length > 0
              )
              if (getPoValue && getPoValue.length > 0) {
                return getPoValue
              }
              return []
            }
          }
          return totalPo()
        }

        const riskCategoryFilter = () => {
          if (manual) {
            if (
              manual.indexOf('RISK_CATEGORY_MIN') > -1 &&
              manual.indexOf('RISK_CATEGORY_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('RISK_CATEGORY_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('RISK_CATEGORY_MAX')) + 1]
              )
              const riskValue = poValue().filter(
                score =>
                  min > score('SCORE_FOR_K3L_PREQ_MIN') &&
                  max < score('SCORE_FOR_K3L_PREQ_MAX')
              )
              if (riskValue && riskValue.length > 0) {
                return riskValue
              }
              return []
            }
          }
          return poValue()
        }

        const csiFinalAdjFilter = () => {
          if (manual) {
            if (manual.indexOf('CSI_FINAL_ADJ') > -1) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('CSI_FINAL_ADJ')) + 1]
              )
              const getCsiFinal = riskCategoryFilter().filter(
                score => min == calculateCsiScore(score.po)
              )
              if (getCsiFinal && getCsiFinal.length > 0) {
                return getCsiFinal
              }
              return []
            }
          }
          return riskCategoryFilter()
        }

        const vendorCategoryFilter = () => {
          if (manual) {
            if (
              manual.indexOf('VENDOR_CATEGORY_MIN') > -1 &&
              manual.indexOf('VENDOR_CATEGORY_MAX') > -1
            ) {
              const min = parseInt(
                manual[parseInt(manual.indexOf('VENDOR_CATEGORY_MIN')) + 1]
              )
              const max = parseInt(
                manual[parseInt(manual.indexOf('VENDOR_CATEGORY_MAX')) + 1]
              )
              const getVendorCategory = csiFinalAdjFilter().filter(
                score => min <= calSpm(score.SPM) && max >= calSpm(score.SPM)
              )
              if (getVendorCategory && getVendorCategory.length > 0) {
                return getVendorCategory
              }
              return []
            }
          }
          return csiFinalAdjFilter()
        }

        if (vendorCategoryFilter() && vendorCategoryFilter().length > 0) {
          store.state.itemTable = vendorCategoryFilter()
          store.state.csv_data = null
        } else {
          state.modalFetch = true
          state.statusFetch = 'Supplier not found!'
          store.state.itemTable = []
          store.state.csv_data = null
        }
      } else {
        state.modalFetch = true
        state.statusFetch = data.message
        store.state.itemTable = []
        store.state.csv_data = null
      }
      state.loading = false
    } catch (error) {
      state.loading = false
      state.modalFetch = true
      state.statusFetch = 'Error, Fetching Data Failed!'
      store.state.itemTable = []
      store.state.csv_data = null
    }
  },
  [types.SET_FILTER_FIELD](state, fieldCategory) {
    state.fieldsToFilter = fieldCategory
  },
}
